import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { useFormInputLayout, FormInputLayout, } from '../FormInputLayout/FormInputLayout';
import * as styles from './FormInputPassword.module.scss';
import { hintMessage as hintMessageStyle } from '../FormInputLayout/FormInputLayout.module.scss';
import { useFormInputStyles } from '../FormInputText/FormInputText';
import { IconButton } from '../../IconButton/IconButton';
import { ComponentTextSmall } from '../../Typography/Typography';
const Name = 'FormInputPassword';
export const FormInputPassword = props => {
    const { register } = useFormContext();
    const { className, componentProps: { children, trim, ...otherComponentProps }, dependentFields, disabled, hint, id, label, labelledBy, name, required, } = useFormInputLayout(props);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const fieldStyles = clsx(useFormInputStyles({ iconAlign: 'end' }), styles.container);
    const hintStyle = clsx(hintMessageStyle);
    if (!id)
        return null;
    const registered = register(name, {
        deps: dependentFields,
        disabled,
        setValueAs: trim ? s => `${s}`.trim() : undefined,
    });
    return (_jsx(FormInputLayout, { className: className, "data-component": Name, disabled: disabled, fieldId: id, hint: children ? undefined : hint, label: label, labelledBy: labelledBy, name: name, required: required, renderInput: state => {
            const { hintId, inputId, isValid, labelId } = state;
            return (_jsxs(_Fragment, { children: [_jsxs("div", { className: fieldStyles, "data-invalid": !isValid, children: [_jsx("input", { id: inputId, "aria-labelledby": labelId, "aria-invalid": !isValid, type: isPasswordVisible ? 'text' : 'password', "aria-describedby": hintId, ...registered, ...otherComponentProps }), _jsx(IconButton, { title: isPasswordVisible ? 'hide password' : 'show password', icon: isPasswordVisible ? 'eye-open' : 'eye-closed', size: "large", variant: "transparent", onClick: () => setIsPasswordVisible(!isPasswordVisible) })] }), children && hint ? (_jsx("div", { id: hintId, className: hintStyle, children: _jsx(ComponentTextSmall, { children: hint }) })) : (''), children] }));
        } }));
};
